import { render, staticRenderFns } from "./invigilatorList.vue?vue&type=template&id=ee1526b4&"
import script from "./invigilatorList.vue?vue&type=script&lang=js&"
export * from "./invigilatorList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports